import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AssembleSetting } from '~/models/administration/assembleSetting';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class AssembleSettingsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    getAssembleSettings() {
        return this.http.get<AssembleSetting>(this._url());
    }

    updateAssembleSettings(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/AssembleSettings${v}`);
    }
}
